// bryan - entire file
window.lang = window.lang || {};

lang.init = function () {
	lang.locationSetup();
};

lang.var_id = {
		'en-us' : 28543595527,
		'en' : 28543595527,
		//'en-nz' : 28543595847,
		//'nz' : 28543595847
		'en-at' : 28543595655, // test
		'en-au' : 28543595655,
		'au' : 28543595655
};

lang.locationSetup = function () {
	var language = Cookies.get('language');
	console.log('language: ', language);
	if( language == 'en-at' ){
		lang.addLanguage( language );
	}

	if( !language  ){
		language = window.navigator.language.toLowerCase();
		Cookies.set('language', language);
		//lang.addLanguage( language );
	}
};

lang.addLanguage = function (language){
	// we don't need to add us to language - it is the default
	var var_id = lang.var_id[language];
	if( var_id ){
		lang.addVariant( var_id );
	}
}

lang.addVariant = function( var_id ) {
		var found_country_item = false;
		$.getJSON( "/cart.js", function( data ) {
			console.log('data: ', data);
			for (var i=0; i < data.items.length; i++) {
				var handle = data.items[i].handle;
				console.log('handle: ', handle);
				if(  handle == 'country'){
					found_country_item = true;
				}
			}
			console.log('found_country_item: ', found_country_item);
			if( ! found_country_item ){
				Helpers.addItem( var_id, 1);
				setTimeout( function(){
					window.location.reload();
				}, 400 );
			}
		});
}

lang.remove_language_from_cart = function(){
	for (var key in lang.var_id) {
		Helpers.removeItem( lang.var_id[key], 1);
    console.log(lang.var_id[key] + ' removed from cart');
	}
	//Cookies.set('language', '');
}


// Initialize lang's JS on docready
$(lang.init)



